import createChainedFunction from 'utils/createChainedFunction';
import EventTracking from 'lib/EventTracking';

const TRACKING_SCREEN_NAME = 'desktop_notification';

export type Options = {
  body: string;
  onclick?: Function;
  onerror?: Function;
  tag?: string;
  title: string;
  tracking?: any;
  icon?: string;
};

/*
  This class is a wrapper around the Notification class.
  Adds additional functionalities such as storing the Notification without showing it,
  as well as being able to change its properties before dispatching it
*/
class WebNotification {
  constructor(options: Options) {
    this._options = options;
    this._dispatchedNotification = null;
    this._dismissed = false;
    this.pingSound = new window.Audio(require('assets/audio/pn.mp3'));
  }

  _options: Options;
  _dismissed: boolean;
  // @ts-expect-error
  _dispatchedNotification: window.Notification | undefined | null;
  // @ts-expect-error
  pingSound: window.Audio;

  setOnClick(onClick: Function) {
    this._options.onclick = onClick;
  }

  dispatch() {
    if (!this.isDismissed()) {
      this.pingSound.play();

      const { title, onclick, onerror, ...others } = this._options;
      const notification = new window.Notification(title, others);
      const trackClick = () =>
        EventTracking.tap(TRACKING_SCREEN_NAME, TRACKING_SCREEN_NAME, null, this._options.tracking);
      // @ts-expect-error
      notification.onerror = onerror;
      notification.onclose = () => {
        this._dismissed = true;
      };
      // @ts-expect-error
      notification.onclick = createChainedFunction(
        createChainedFunction(onclick, trackClick),
        notification.close
      );
      this._dispatchedNotification = notification;
      EventTracking.view(TRACKING_SCREEN_NAME, this._options.tracking);
    }
  }

  dismissNotification() {
    if (this._dispatchedNotification) {
      this._dispatchedNotification.close();
    } else {
      this._dismissed = true;
    }
  }

  isDispatched() {
    return !!this._dispatchedNotification;
  }

  isDismissed() {
    return this._dismissed;
  }

  // TODO refactor "tag" concern so it doesn't have to be parsed
  getTag() {
    return this._options.tag;
  }
}

export default WebNotification;
